import { ApiCore } from "./core";

const url = "folders";
const apiClient = new ApiCore({
  list: true,
  get: true,
  post: true,
  put: true,
  delete: true,
  url
});

export const foldersApi = apiClient;